import { Skeleton, Typography } from "@mui/material"
import { groupBy } from "@shared/lib/utils";
import MuiInput from "@shared/ui/mui-input/MuiInput";
import { UseFormReturn } from "react-hook-form";
import { AccountAdd } from "../../../../../models/account";
import { StyledAddCashBox } from "./AddCashBox.styled";
import { useGetAccountStructureQuery } from "@features/structures/api/accountsStructure.api";
import { useTheme } from "@emotion/react";


interface AddCashBoxProps {
  useForm: UseFormReturn<AccountAdd>
}

function AddCashBox({ useForm }: AddCashBoxProps) {
  
  const theme = useTheme();

  const { 
    data: cashBoxStructure,
    isFetching,
  } = useGetAccountStructureQuery("קופה");

  const structureSortedByTitle = groupBy(cashBoxStructure, "account_title")
  const customFieldsExist = structureSortedByTitle?.["מותאם אישית"]?.find(structure=> !!structure.show_form === true);


  return (
    <StyledAddCashBox>
      {isFetching && (<Skeleton variant="rectangular" height={500} animation="wave" sx={{ bgcolor: theme.colors.section_color }} />)}
      {!isFetching && cashBoxStructure &&
        <>
          <div>
            <Typography variant="body1">פרטים:</Typography>
            <div className="fields">
              {structureSortedByTitle?.["פרטים"]?.map(field => {
                return field.show_form ? <MuiInput key={field.field_name} field={field} variant='outlined' useForm={useForm} showRequired/> : null
              })}
            </div>
          </div>

          <div>
            {customFieldsExist && (<Typography variant="body1">שדות מותאמים אישית:</Typography>)}
            <div className="fields">
              { structureSortedByTitle?.["מותאם אישית"]?.map(field => {
                return field.show_form ? <MuiInput key={field.field_name} field={field} variant='outlined' useForm={useForm} showRequired/> : null
              })}
            </div>
          </div>

        </>}

    </StyledAddCashBox>
  )
}

export default AddCashBox